// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import Logo from '../Logo';

interface BiometricSetupProps {
  biometricLabel: string;
  onEnable: () => void;
  onSkip: () => void;
}

/** Offer to enroll biometric authentication after a successful password login */
export default function BiometricSetup({ biometricLabel, onEnable, onSkip }: BiometricSetupProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-brand-50 via-white to-white px-4 py-10">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-md text-center">
        <div className="mb-4 flex justify-center">
          <Logo variant="full" size="lg" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-slate-900">
          Use {biometricLabel} to sign in?
        </h2>
        <p className="mb-6 text-sm text-slate-600">
          Sign in faster next time using {biometricLabel} instead of your password.
        </p>
        <div className="space-y-3">
          <button
            type="button"
            onClick={onEnable}
            data-testid="biometric-enable"
            className="w-full rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-200"
          >
            Enable {biometricLabel}
          </button>
          <button
            type="button"
            onClick={onSkip}
            data-testid="biometric-skip"
            className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
